import { useEffect, useState } from 'preact/hooks';
import { useLocation } from 'preact-iso';
import { routes } from '@/utils/routes';
const tabPatterns = [
    { tab: 'leads', pattern: /\/web\/[^/]+\/leads(\/companies)?$/ },
    { tab: 'activations', pattern: /\/web\/[^/]+\/activations$/ },
    { tab: 'meetings', pattern: /\/web\/[^/]+\/meetings$/ },
    { tab: 'calendar', pattern: /\/web\/[^/]+\/calendar$/ },
    { tab: 'media', pattern: /\/web\/[^/]+\/media$/ },
    { tab: 'landing-page', pattern: /\/web\/[^/]+\/landing-page$/ },
    { tab: 'settings', pattern: /\/web\/[^/]+\/settings$/ },
    { tab: 'details', pattern: /\/web\/[^/]+$/ },
];
export function useWebTabRouter({ clientCompanyId, workspaceId, campaignId, webId }) {
    const location = useLocation();
    const [activeTab, setActiveTab] = useState('details');
    useEffect(() => {
        const rawPath = location?.path
            || location?.url
            || (typeof window !== 'undefined' ? window.location.pathname : '');
        for (const { tab, pattern } of tabPatterns) {
            if (pattern.test(rawPath) && activeTab !== tab) {
                setActiveTab(tab);
                break;
            }
        }
    }, [location]);
    const scoped = routes.scoped(clientCompanyId, workspaceId);
    const routeToTab = (tab) => {
        setActiveTab(tab);
        const basePath = scoped.web(campaignId, webId);
        const target = tab === 'details' ? basePath : `${basePath}/${tab}`;
        try {
            location.route(target);
        }
        catch {
            if (typeof window !== 'undefined')
                window.history.pushState({}, '', target);
        }
    };
    return { activeTab, routeToTab };
}
